const ShopButton = {
  parts: [
    'shopButton',
    'shopIcon',
    'shopButtonText'
  ],
  baseStyle: {
    shopButton: {
      appearance: 'none',
      border: 'none',
      display: 'flex',
      p: 3, // 12px
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5, // 10px
      borderRadius: 'base', // 4px
      font: 'inherit',
      bg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), rgba(27, 26, 24, 0.30)',
      backdropFilter: 'blur(10px)',
      cursor: 'pointer',
      color: 'white',
      _hover: {
        bg: 'linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), rgba(27, 26, 24, 0.40)',
      },
      transition: 'background 0.2s ease',
    },
    shopIcon: {
      width: 5, // 20px
      height: 5, // 20px
      display: 'flex',
      sx: {
        ' svg': {
          width: '100%',
          height: '100%',
        },
      },
    },
    // Figma Desktop/text.label.small — label on gradient bar next to shop icon
    shopButtonText: {
      color: 'white',
      textAlign: 'center',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
    },
  },
};

export default ShopButton;
